<template>
  <div class="wrap">
    <Sticky offset-top="0">
      <NavBar :title="$t('homeRedesign.navCart')"/>
    </Sticky>
    <Tabs v-model="currentStatus" sticky offset-top="46" color="var(--color-primary)">
      <Tab v-for="(item,index) in tabs" :key="index" :title="$t(item.label)">
        <JList class="cart-list" list custom-list pull-refresh :full-screen="false" :per-page="10"
          url="/task/getTaskOrder" :init-param-data="{status: item.value, page_size: 10}"
          :null-img="emptyImage" :ref="`list_${index}`">
          <template #listItem="{data}">
            <div class="list_item">
              <div class="list_item-content">
                <div class="list_item-content-left">
                  <img :src="$img(data.product_picture)"/>
                </div>
                <div class="list_item-content-right">
                  <div class="list_item-content-right-title">
                    {{ data.product_name }}
                  </div>
                  <div class="list_item-content-right-bottom">
                    <div class="list_item-content-right-bottom-left">
                      <div class="list_item-content-right-bottom-left-price">
                        {{ $money(data.price || 0) }}
                      </div>
                      <div class="list_item-content-right-bottom-left-quantity">
                        {{ $t('product.buyNum') }}{{ data.amount != null ? data.amount : (data.num || 0) }}
                      </div>
                      <!--                      <div class="list_item-content-right-bottom-left-rate">-->
                      <!--                        <trans label="product.record.rate" :options="{__: rateText(data)}"/>-->
                      <!--                      </div>-->
                    </div>
                    <div class="list_item-content-right-bottom-right" v-if="data.status === 0"
                         @click.stop="handlePay(data, index)">
                      <trans label="product.record.toPay"/>
                    </div>
                    <div class="list_item-content-right-bottom-right" v-if="data.delivery_status === 2"
                         @click.stop="handleReceived(data, index)">
                      <trans label="product.record.received"/>
                    </div>
                    <!--                    <div class="list_item-content-right-bottom-right" v-else-if="data.status === 5">-->
                    <!--                      <trans label="listStatus.cancel"/>-->
                    <!--                    </div>-->
                    <!--                    <div class="list_item-content-right-bottom-right" v-else>-->
                    <!--                      <trans-->
                    <!--                          label="product.record.willGet"-->
                    <!--                          :options="{__: $money(allGet(data))}"/>-->
                    <!--                    </div>-->
                  </div>
                </div>
              </div>
              <div class="list_item-step">
                <Steps :active="status.indexOf(data.status)" active-color="var(--color-primary-strong)" v-if="item.value === 'ing'">
                  <Step>
                    <trans label="product.step.bidSuccess"/>
                  </Step>
                  <Step>
                    <trans label="product.step.paySuccess"/>
                  </Step>
                  <Step>
                    <trans label="product.step.done"/>
                  </Step>
                </Steps>
                <Steps :active="wonStatus.indexOf(data.delivery_status)" active-color="var(--color-primary-strong)" v-else-if="data.delivery_status > 0">
                  <Step>
                    <trans label="product.step.dropshipping"/>
                  </Step>
                  <Step>
                    <trans label="product.step.shipping"/>
                  </Step>
                  <Step>
                    <trans label="product.step.done"/>
                  </Step>
                </Steps>
              </div>
            </div>
          </template>
        </JList>
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import {NavBar, Tabs, Tab, Steps, Step, Toast, Sticky, Dialog} from 'vant';
import JList from "@/components/j-list.vue";
import emptyImage from "@/assets/Img/null/null.png";
import {PAY_TASK_ORDER, ORDER_RECEIVED} from "@tt/api";

export default {
  components: {
    NavBar, JList, Tabs, Tab, Steps, Step, Sticky
  },
  data: () => ({
    emptyImage,
    tabs: [
      {
        label: 'listStatus.progress',
        value: 'ing',
      },
      {
        label: 'listStatus.done',
        value: 2,
      }
    ],
    status: [0, 1, 2, 5],
    wonStatus: [1, 2, 3],
    currentStatus: 0,
  }),
  methods: {
    allGet(item) {
      return this.commission(item) + item.total_price * 1;
    },
    commission: (item) => item.rate / 100 * item.total_price,
    rateText(item) {
      return `${item.rate}%=${this.$money(this.commission(item))}`
    },
    async handlePay(item, parentIndex) {
      try {
        const {msg} = await PAY_TASK_ORDER(item.id);
        Toast(msg)
        this.$refs[`list_${parentIndex}`][0].handleRefresh();
      } catch (e) {
        console.error(e.data)
        const { msg } = e.data
        Toast(msg)
      }
    },
    handleReceived(item, parentIndex) {
      const _this = this;
      Dialog.confirm({
        title: _this.$t("product.record.receivedWarningTitle"),
        message: _this.$t("product.record.receivedWarningContent"),
        confirmButtonText: _this.$t("btn.confirm"),
        cancelButtonText: _this.$t("btn.cancel")
      }).then(async () => {
        try {
          const {msg} = await ORDER_RECEIVED(item.id)
          Toast(msg)
          this.$refs[`list_${parentIndex}`][0].handleRefresh();
        } catch (e) {
          console.error(e)
          Toast(e)
        }
      }).catch(()=> {
        console.log("点击取消")
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@tt/assets/cssLib/lib.less";

.cart-list {
  --bg: var(--page-background);
}
/deep/ .wrap{
  background-color: transparent;
  .nodata{
    background-color: transparent;
  }
}
.list_item {
  margin: 8px;
  border-radius: @radius-m;
  background: #fff;
  padding: 8px;

  &-header {
    .flex(@hor: space-between, @ver: center);
    padding-bottom: 6px;
    border-bottom: 1px solid #eee;

    &-left {
      font-size: 16px;
      color: var(--color-primary-strong);
      .flex(@ver: center);

      > img {
        @size: 26px;
        margin-right: 4px;
        width: @size;
        height: @size;
      }
    }

    &-right {
      color: #666;

      > span:nth-last-child(1) {
        color: var(--color-primary-strong);
      }
    }
  }

  &-content {
    margin-top: 6px;
    .flex();

    &-left {
      @size: 50px;
      width: @size;
      height: @size;
      margin-right: 6px;
      flex-shrink: 0;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    &-right {
      padding-top: 4px;

      &-title {
        .ellipsis(2);
        font-size: 14px;
        line-height: 1.2;
      }

      &-bottom {
        .flex(@hor: space-between; @ver: flex-end);

        &-left {

          &-price {
            font-size: 14px;
            margin: 10px 0;
            color: var(--color-price);
          }

          &-quantity {
            color: #666;
            font-size: 12px;
            line-height: 1.5;
          }

          &-rate {
            padding: 6px 4px;
            font-size: 12px;
            color: #f5f5f5;
            background: #B16802;
            border-radius: @radius-s;
          }
        }

        &-right {
          border-radius: @radius-m;
          padding: 8px 6px;
          font-size: 14px;
          background: var(--button-background);
          color: var(--button-text);
        }
      }
    }
  }
}
</style>
